"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
const Cube_1 = require("./Cube");
class OLAPService {
    constructor(apiService, mddeApiService, dictionariesService) {
        this._olapMetadataApiService = apiService;
        this._mddeApiService = mddeApiService;
        this._dictionariesService = dictionariesService;
    }
    getCubeDefinition(id) {
        return __awaiter(this, void 0, void 0, function* () {
            // TODO: add cache
            const def = yield this._olapMetadataApiService.getCubeDefinition(id);
            return def;
        });
    }
    getCube(resolveOptions) {
        return __awaiter(this, void 0, void 0, function* () {
            const { id } = resolveOptions;
            const definition = yield this.getCubeDefinition(id);
            const parametersValues = resolveOptions.parameters || {};
            // build attributes matadata
            // collect dimensions
            const attributesMetadata = Object
                .entries(definition.dimensions)
                .reduce((acc, [dimId, dim]) => {
                //collect hierarchies, build complex path
                Object
                    .entries(dim.hierarchies)
                    .forEach(([hieId, hie]) => {
                    const fullId = `${dimId}.${hieId}`;
                    const attributeMetadata = {
                        path: fullId,
                        dictionaryBinding: hie.dictionaryBinding
                    };
                    acc.set(fullId, attributeMetadata);
                });
                return acc;
            }, new Map());
            // validate cube parameters
            // TODO: сделать в словарях валидацию на уровне сервиса
            Cube_1.Cube.validateParameters(definition, parametersValues, attributesMetadata);
            // build resolve parameters for each dictionary
            const attrsInfo = Array
                .from(attributesMetadata.values())
                .map((attrMeta) => {
                const { dictionaryId, parametersBinding } = attrMeta.dictionaryBinding;
                const dictParams = parametersBinding === null || parametersBinding === void 0 ? void 0 : parametersBinding.reduce((acc, { cubeParameterId, dictionaryParameterId }) => {
                    const paramValue = parametersValues[cubeParameterId];
                    acc[dictionaryParameterId] = paramValue;
                    return acc;
                }, {});
                const resolveOpt = {
                    id: dictionaryId,
                    parameters: dictParams,
                };
                return {
                    path: attrMeta.path,
                    resolveOptions: resolveOpt,
                };
            });
            const dictResolveOptions = attrsInfo.map((x) => x.resolveOptions);
            const dictionariesMap = yield this._dictionariesService.getDictionaries(dictResolveOptions);
            const attrsDicts = new Map(attrsInfo.map((x) => [x.path, dictionariesMap.get(x.resolveOptions.id)]));
            // TODO: generate measures dict
            const cube = new Cube_1.Cube(this._mddeApiService, definition, attrsDicts, parametersValues);
            return cube;
        });
    }
}
exports.OLAPService = OLAPService;
//# sourceMappingURL=OLAPService.js.map